import script from "./studyItemEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./studyItemEvent.vue?vue&type=script&setup=true&lang=js"

import "./studyItemEvent.vue?vue&type=style&index=0&id=5c57dddf&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c57dddf"]])

export default __exports__